import { Pipe, PipeTransform } from '@angular/core';
import { EmailAttemptStatus } from '@workspace/data-types';
import { CoreNiceLabelUtils } from '../core-nice-label.utils';

@Pipe({
  name: 'emailAttemptStatusDisplay',
})
export class EmailAttemptStatusDisplayPipe implements PipeTransform {
  transform(value: EmailAttemptStatus): string {
    return emailAttemptStatusDisplayTransform(value);
  }
}

export function emailAttemptStatusDisplayTransform(value: EmailAttemptStatus) {
  return CoreNiceLabelUtils.emailAttemptStatus(value);
}
